import { useLocation } from 'react-router-dom';
import * as React from 'react';
import { useEffect, useContext } from 'react';
import { appPath } from '@web3/base-utils';
import { scTrack, PageViewConfigInfo } from '@web3/base-tracking';

const localeRegStr = '(en)|([a-z]{2,3}-[A-Z0-9]{2,3})';
const localeReg = new RegExp(`^/(${localeRegStr})/`);

function getLocaleFromPathname(pathname: string): string {
  return pathname.match(localeReg)?.[1] ?? '';
}

function getPath(pathname: string, locale: string, symbol = appPath): string {
  return pathname.replace(`/${locale}/${symbol}`, '').replace(/^\//, '');
}

/**
 * React Context for TrackInfo
 */
export const TrackInfoContext = React.createContext({
  config: [],
  eventPageViewName: '',
});

TrackInfoContext.displayName = 'TrackInfoContext';

interface TrackInfoProviderProps {
  children: React.ReactNode;
  config: PageViewConfigInfo[];
  eventPageViewName?: string;
  systemSymbol?: string;
}

export const TrackInfoProvider = (props: TrackInfoProviderProps) => {
  const {
    children,
    config,
    eventPageViewName = 'Web3PageView',
    systemSymbol,
  } = props;
  const location = useLocation();

  useEffect(() => {
    const { pathname, search } = location;

    const locale = getLocaleFromPathname(pathname);
    const path = getPath(pathname, locale, systemSymbol);
    // TODO：需要考虑动态path的匹配
    const fc = config.filter((c) => c.page_url === path);
    if (fc) {
      // 先匹配path
      if (fc.length === 1) {
        scTrack(eventPageViewName, {
          page_name: fc[0].page_name as any,
          notify_lang: locale,
        });
      } else {
        // 再匹配search
        const c = fc.find((f) => (f as any).search === search);
        c &&
          scTrack(eventPageViewName, {
            page_name: c.page_name as any,
            notify_lang: locale,
          });
      }
    }
  }, [location.pathname, location.search]);

  return (
    <TrackInfoContext.Provider
      value={{
        config,
        eventPageViewName,
      }}
    >
      {children}
    </TrackInfoContext.Provider>
  );
};
/**
 * Custom React Hooks
 */
export const useTrackInfo = () => {
  const context = useContext(TrackInfoContext);
  return context;
};

export default TrackInfoContext;
